import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import AuthService from "../../utils/AuthService";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  ListItemText,
  Paper,
  Box,
  Button,
  Typography,
  Grid,
  Card,
  Collapse,
  LinearProgress,
  useMediaQuery,
  Divider,
  FormControlLabel,
  CardContent,
} from "@mui/material";
import ApiMap from "../../utils/ApiMap";
import data from "./assignmentconfig.json";
import axios from "axios";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const Assignment = () => {
  //const { columns, data: rowData } = data.Content;
  const [userInputs, setUserInputs] = useState({});
  const [facultyInputs, setFacutlyInputs] = useState({});
  const userAssignmentId = useRef();
  const location = useLocation();
  const [myAssignment, setMyAssignment] = useState();
  const [assignmentId, setAssignmentId] = useState(null);
  const [userAssignment, setUserAssignment] = useState(null);
  const [assignment, setAssignment] = useState(null);
  const [assignmentInfo, setAssignmentInfo] = useState({});
  const [submissions, setSubmissions] = useState(null);
  const [showSubmissions, setShowSubmissions] = useState(true);
  const [loadingAssignment, setLoadingAssignment] = useState(true);
  const [loadingSubmissions, setLoadingSubmissions] = useState(true);
  const { courseId, moduleId, chapterId, contentId } = location.state || {};
  const [selectedStudentIndex, setSelectedStudentIndex] = useState(null);
  const [resubmitChecked, setResubmitChecked] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [updating, setUpdating] = useState(false);

  const isMobile = useMediaQuery("(max-width:600px)");

  const isInstructor = AuthService.isFaculty(courseId);

  const getAssignment = async () => {
    if (assignmentId > 0) {
      return;
    }
    const resp = await axios(
      `${ApiMap.MYASSIGNMENT}/myassignment/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`,
      AuthService.getAuthHeader()
    );
    console.log(resp);
    if (resp.data.UserAssignmentId) {
      //setUserAssignmentId(resp.data.UserAssignmentId);
      userAssignmentId.current = resp.data.UserAssignmentId;
      console.log(resp.data);
      setUserAssignment(resp.data.Assignment);
      var myA = {};
      myA.GradeSubmitDate = resp.data.SubmitDate;
      myA.UserAssignmentId = resp.data.UserAssignmentId;
      myA.Assignment = resp.data.Assignment;
      myA.Score = resp.data.StudentScore;
      myA.MemberId = resp.data.MemberId;
      myA.GradedDate = resp.data.GradedDate;
      myA.TeacherComment = resp.data.TeacherComment;
      myA.StudentComment = resp.data.Studentcomment;
      myA.Resubmit = resp.data.ReSubmit;
      myA.AssignmentScore = resp.data.AssignmentScore;
      setMyAssignment(myA);
    } else {
      setUserAssignment(resp.data.Content);
    }

    if (!assignment) {
      setAssignment(resp.data.Content);
    }
    var ainfo = {};
    ainfo.Title = resp.data.Title;
    ainfo.Name = resp.data.Name;
    ainfo.CourseName = resp.data.CourseName;
    ainfo.ModuleName = resp.data.ModuleName;
    ainfo.Duration = resp.data.DurationMin;
    ainfo.Score = resp.data.AssignmentScore;
    setAssignmentInfo(ainfo);
    setAssignmentId(resp.data.AssignmentId);
    setLoadingAssignment(false);
  };

  useEffect(() => {
    console.log("useEffect");
    const source =
      selectedStudentIndex !== null &&
      submissions?.[selectedStudentIndex]?.Assignment
        ? submissions[selectedStudentIndex].Assignment
        : userAssignment;

    if (!source?.data || !source?.columns) return;
    setColumns(source.columns);
    const transformedData = source.data.map((row, rowIndex) =>
      row.map((cell, colIndex) => {
        const isTeacherCommentRow = source.columns[rowIndex]?.name
          ?.toLowerCase()
          .includes("teacher");
        if (isTeacherCommentRow) {
          return cell; // Don't convert teacher's comment
        }

        const assignmentCell = assignment.data?.[rowIndex]?.[colIndex];

        if (typeof assignmentCell === "string") {
          return { type: "question", value: assignmentCell };
        }

        if (Array.isArray(cell)) {
          return {
            type: "picklist",
            picklist: cell.map((option) => ({
              value: option?.value || "",
              isCorrect: !!option?.isCorrect,
              submittedValue: !!option?.submittedValue,
            })),
          };
        }

        if (typeof cell === "object" && cell?.type) {
          return cell;
        }

        return {
          type: "text",
          submittedValue:
            typeof cell === "string" || typeof cell === "number" ? cell : "",
          answer: "",
        };
      })
    );
    console.log(transformedData);
    setRowData(transformedData);
    setUserInputs({});
  }, [assignment, submissions, selectedStudentIndex]);

  useEffect(() => {
    if (selectedStudentIndex === null || !submissions[selectedStudentIndex])
      return;

    const currentSubmission = submissions[selectedStudentIndex];
    setResubmitChecked(!!currentSubmission?.Resubmit);
  }, [selectedStudentIndex, submissions]);

  const getSubmissions = async () => {
    const resp = await axios(
      `${ApiMap.MYASSIGNMENT}/assignmentstograde/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`,
      AuthService.getAuthHeader()
    );
    setSubmissions(resp.data);
    setLoadingSubmissions(false);
  };

  useEffect(() => {
    if (assignmentId < 1) {
      getAssignment();
    }
  }, [assignmentId]);

  useEffect(() => {
    if (
      AuthService.isFaculty(courseId) &&
      assignmentId != null &&
      !submissions
    ) {
      getSubmissions();
    }
  });
  const getCellBackground = useCallback(
    (rowIndex, colIndex) => {
      const isTeacherColumn = columns?.[colIndex]?.name
        ?.toLowerCase()
        .includes("teacher");
      if (isTeacherColumn) return "inherit"; // no background for teacher columns

      const originalCell = assignment?.data?.[colIndex]?.[rowIndex];
      let submittedCell;
      if (isInstructor) {
        // Instructor is viewing a student's submission
        submittedCell =
          submissions?.[selectedStudentIndex]?.Assignment?.data?.[colIndex]?.[
            rowIndex
          ];
      } else {
        // Student is logged in — check their own submitted data
        submittedCell = userAssignment?.data?.[colIndex]?.[rowIndex];
      }

      if (!originalCell && submittedCell) return "#ffebee"; // student entered only
      if (originalCell && submittedCell && originalCell !== submittedCell)
        return "#fff9c4"; // mismatch
      return "inherit"; // same or no data
    },
    [assignment, submissions, selectedStudentIndex, userInputs, isInstructor]
  );

  const handlePicklistChange = (rowIndex, colIndex, selectedValues) => {
    setUserInputs((prev) => ({
      ...prev,
      [`${rowIndex}-${colIndex}`]: selectedValues,
    }));
    rowData[colIndex][rowIndex].submittedValue = selectedValues;
  };

  const handleTextChange = (rowIndex, colIndex, value) => {
    setUserInputs((prev) => ({
      ...prev,
      [`${rowIndex}-${colIndex}`]: value,
    }));
  };

  const handleSubmitAssignment = async (action) => {
    let studentId;
    let assignmentId;
    let currentSubmission;
    console.log(submissions);
    // Determine if it's instructor mode (selected student) or student mode
    if (selectedStudentIndex !== null && submissions[selectedStudentIndex]) {
      // Instructor mode
      currentSubmission = submissions[selectedStudentIndex];
      studentId = currentSubmission?.MemberId;
      assignmentId = currentSubmission?.Id;
    } else if (userAssignment) {
      // Student mode
      console.log(assignment);
      currentSubmission = userAssignment;
      studentId = currentSubmission?.MemberId;
      assignmentId = currentSubmission?.Id;
    } else {
      console.error("No student or assignment found");
      return;
    }

    console.log(studentId);
    // Create 'data' rows (rows of values, not columns)
    // const maxRows = Math.max(...rowData.map((col) => col.length));
    console.log(userInputs);
    const maxRows = Math.max(...rowData.map((col) => col.length));
    const maxCols = columns.length;

    const formattedData = Array.from({ length: maxCols }, (_, colIndex) =>
      Array.from({ length: maxRows }, (_, rowIndex) => {
        const key = `${rowIndex}-${colIndex}`;
        const userInput = userInputs[key];

        const cell = rowData[colIndex]?.[rowIndex];
        const submitted =
          typeof cell === "object" ? cell.submittedValue : undefined;
        const original = typeof cell === "object" ? cell.value : cell; // fallback to raw string for teacher comments

        return userInput ?? submitted ?? original ?? "";
      })
    );

    console.log(formattedData);
    // Create the correct structure: { Value: { columns, data }, Id?, StudentId? }
    const assignmentObj = {
      Value: {
        lines: 1, // Add this if it's required
        columns: columns.map((col) => ({ name: col.name })), // or include style, width if needed
        data: formattedData,
      },
    };

    if (userAssignmentId.current) {
      assignmentObj["Id"] = parseInt(userAssignmentId.current);
    }

    if (studentId) {
      assignmentObj["StudentId"] = studentId;
    }

    console.log(assignmentObj);
    var url = `${ApiMap.UPDT_ASSIGNMENT}/userassignment/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`;
    async function update() {
      try {
        const response = await axios.post(
          url,
          assignmentObj,
          AuthService.getAuthHeader()
        );
        if (response.status === 200) {
        }
      } catch (err) {
        console.log(err);
      }
    }
    update();
  };

  // const handleResubmit = (submission) => {
  //   console.log("Resubmit clicked for:", submission.FirstName);
  //   // Implement your resubmit logic here
  // };

  const handleGradeSubmit = (
    submission,
    newStudentScore,
    gradeComment,
    resubmit
  ) => {
    const assignmentObj = {
      comment: gradeComment,
      score: newStudentScore,
      resubmit: resubmit,
      Id: submission.UserAssignmentId,
      studentId: submission.MemberId,
      assignmentGrades: submission.AssignmentScore,
    };
    setUpdating(true);
    var url = `${ApiMap.UPDT_ASSIGNMENT}/gradeassignment/${courseId}/module/${moduleId}/chapter/${chapterId}/lesson/${contentId}`;
    async function update() {
      try {
        const response = await axios.post(
          url,
          assignmentObj,
          AuthService.getAuthHeader()
        );
        setUpdating(false);
        if (response.status >= 200 && response.status < 300) {
          const updatedSubmissions = [...submissions];
          updatedSubmissions[selectedStudentIndex] = {
            ...submissions[selectedStudentIndex],
            Resubmit: resubmit, // Add this field if not present
          };
          setSubmissions(updatedSubmissions);
        }
      } catch (err) {
        console.log(err);
        setUpdating(false);
      }
    }
    update();
    // Implement your backend call or logic here
  };

  if (loadingAssignment) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <LinearProgress color="secondary" sx={{ width: "20%" }} />
        <Typography variant="body2" color="textSecondary">
          Loading assignment...
        </Typography>
      </Box>
    );
  }

  if (loadingSubmissions && isInstructor) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <LinearProgress color="secondary" sx={{ width: "20%" }} />
        <Typography variant="body2" color="textSecondary">
          Loading submissions...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ direction: "rtl" }}>
      <Box
        sx={{
          direction: "ltr",
          margin: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {AuthService.isFaculty(courseId) && (
          <Box sx={{ margin: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  marginRight: 2,
                  fontSize: "1rem",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "primary.main",
                }}
              >
                Submissions: {submissions?.length}
              </Typography>
              <Button
                variant="text"
                onClick={() => setShowSubmissions((prev) => !prev)}
                sx={{
                  minWidth: 20,
                  padding: 1,
                }}
              >
                {showSubmissions ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Button>
            </Box>
            {showSubmissions && (
              <Collapse in={showSubmissions}>
                {Array.isArray(submissions) && submissions.length > 0 ? (
                  isMobile ? (
                    // Mobile: Display as a List
                    <TextField
                      select
                      label="Select Student"
                      fullWidth
                      variant="outlined"
                      value={selectedStudentIndex ?? ""}
                      onChange={(e) =>
                        setSelectedStudentIndex(Number(e.target.value))
                      }
                      sx={{ marginBottom: 2 }}
                    >
                      {submissions.map((submission, index) => (
                        <MenuItem key={index} value={index}>
                          {submission.FirstName}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : (
                    // Desktop: Display as Grid of Cards
                    <Grid container spacing={2}>
                      {submissions.map((submission, index) => {
                        const scoreKey = `score-${index}`;
                        const commentKey = `comment-${index}`;
                        const isSelected = selectedStudentIndex === index;
                        return (
                          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                            <Card variant="outlined" sx={{ padding: 2 }}>
                              {/* FirstName */}
                              <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                gutterBottom
                                onClick={() => {
                                  if (selectedStudentIndex !== index) {
                                    setSelectedStudentIndex(index);
                                  }
                                }}
                                sx={{
                                  textDecoration: "underline",
                                  color: "primary.main",
                                  cursor: "pointer",
                                }}
                              >
                                {submission.FirstName}
                              </Typography>

                              {/* Submit Date */}
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {new Date(
                                  submission.SubmitDate
                                ).toLocaleString()}
                              </Typography>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  )
                ) : null}

                {selectedStudentIndex !== null && (
                  <Box mt={4}>
                    <Divider sx={{ mb: 2 }} />
                    <Typography variant="h6" gutterBottom>
                      <strong>Grading: </strong>
                      {submissions[selectedStudentIndex]?.FirstName}
                    </Typography>

                    <Typography variant="body2" sx={{ mb: 2 }}>
                      <strong>Grade: </strong>
                      {submissions[selectedStudentIndex].StudentScore} /
                      {submissions[selectedStudentIndex].AssignmentScore}
                    </Typography>

                    {/* Editable StudentScore */}
                    <TextField
                      label="Student Score"
                      type="number"
                      inputProps={{
                        min: 0,
                        max: submissions[selectedStudentIndex].AssignmentScore,
                      }}
                      value={
                        facultyInputs[`score-${selectedStudentIndex}`] ??
                        submissions[selectedStudentIndex].StudentScore
                      }
                      onChange={(e) => {
                        const inputValue = Number(e.target.value);
                        const maxScore =
                          submissions[selectedStudentIndex].AssignmentScore;
                        if (inputValue <= maxScore) {
                          setFacutlyInputs((prev) => ({
                            ...prev,
                            [`score-${selectedStudentIndex}`]: inputValue,
                          }));
                        }
                      }}
                      sx={{
                        mb: 2,
                        width: "100%",
                        maxWidth: 200,
                        minWidth: 100,
                      }}
                    />

                    {/* Editable TeacherComment */}
                    <TextField
                      label="Teacher Comment"
                      multiline
                      rows={4}
                      value={
                        facultyInputs[`comment-${selectedStudentIndex}`] !==
                        undefined
                          ? facultyInputs[`comment-${selectedStudentIndex}`]
                          : submissions[selectedStudentIndex].TeacherComment ||
                            ""
                      }
                      onChange={(e) =>
                        setFacutlyInputs((prev) => ({
                          ...prev,
                          [`comment-${selectedStudentIndex}`]: e.target.value,
                        }))
                      }
                      fullWidth
                      sx={{ mb: 2 }}
                    />
                    {/* Buttons */}
                    <Box display="flex" flexDirection="column" gap={2}>
                      {/* Checkbox */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={resubmitChecked}
                            onChange={(e) =>
                              setResubmitChecked(e.target.checked)
                            }
                            color="secondary"
                          />
                        }
                        label="Resubmit"
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ alignSelf: "flex-start" }}
                        onClick={() =>
                          handleGradeSubmit(
                            submissions[selectedStudentIndex],
                            facultyInputs[`score-${selectedStudentIndex}`] ??
                              submissions[selectedStudentIndex].StudentScore,
                            facultyInputs[`comment-${selectedStudentIndex}`] ??
                              submissions[selectedStudentIndex].TeacherComment,
                            resubmitChecked
                          )
                        }
                      >
                        Grade
                      </Button>
                    </Box>
                  </Box>
                )}
              </Collapse>
            )}
          </Box>
        )}
        {AuthService.isStudent(courseId) && (
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Your Grade
              </Typography>
              <Typography variant="body1" color="primary.main">
                <strong>
                  {myAssignment?.Score} out of {myAssignment?.AssignmentScore}
                </strong>
              </Typography>
              <Typography variant="body1">
                <strong>Submitted:</strong>{" "}
                {new Date(myAssignment?.GradeSubmitDate).toLocaleString(
                  "en-US",
                  {
                    dateStyle: "medium",
                    timeStyle: "short",
                  }
                )}
              </Typography>

              <Typography variant="body1">
                <strong>Status:</strong>
                {myAssignment?.Graded ? "Graded" : "Not Graded Yet"}
              </Typography>
            </CardContent>
          </Card>
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-start", margin: 2 }}>
        <Button
          variant="contained"
          sx={{ marginLeft: 1 }}
          onClick={() => {
            handleSubmitAssignment("submit");
          }}
        >
          Submit
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            handleSubmitAssignment("save");
          }}
        >
          Save
        </Button>
      </Box>
      <TableContainer component={Paper} sx={{ padding: 2, border: "none" }}>
        <Table sx={{ border: "1px solid black" }}>
          <TableHead sx={{ backgroundColor: "primary.main" }}>
            <TableRow>
              {columns.map((col, index) => (
                <TableCell
                  key={index}
                  align="center"
                  style={{
                    width: `${col.width}%`,
                    fontSize: "1rem",
                    fontWeight: 500,
                    color: "#ffffff",
                  }}
                >
                  {col.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({
              length: Math.max(...rowData.map((col) => col.length)),
            }).map((_, rowIndex) => (
              <TableRow key={rowIndex} sx={{ borderBottom: "1px solid black" }}>
                {columns.map((_, colIndex) => {
                  const cellData = rowData[colIndex]?.[rowIndex];
                  const isTeacherCommentColumn = columns[rowIndex]?.name
                    ?.toLowerCase()
                    .includes("teacher");
                  // Question cell
                  if (cellData?.type === "question") {
                    return (
                      <TableCell
                        key={colIndex}
                        align="center"
                        sx={{
                          border: "1px solid grey",
                          fontSize: "1.2rem",
                          backgroundColor: getCellBackground(
                            rowIndex,
                            colIndex
                          ),
                        }}
                      >
                        {cellData.value}
                      </TableCell>
                    );
                  }

                  // Text cell
                  if (cellData?.type === "text") {
                    return (
                      <TableCell
                        key={colIndex}
                        align="center"
                        sx={{
                          border: "1px solid grey",
                          fontSize: "1.2rem",
                          backgroundColor: getCellBackground(
                            rowIndex,
                            colIndex
                          ),
                        }}
                      >
                        <TextField
                          fullWidth
                          variant="standard"
                          value={
                            userInputs[`${rowIndex}-${colIndex}`] ??
                            cellData.submittedValue ??
                            ""
                          }
                          onChange={(e) =>
                            handleTextChange(rowIndex, colIndex, e.target.value)
                          }
                        />
                      </TableCell>
                    );
                  }

                  // Picklist cell
                  if (cellData?.type === "picklist") {
                    return (
                      <TableCell
                        key={colIndex}
                        align="center"
                        sx={{
                          border: "1px solid grey",
                          backgroundColor: getCellBackground(
                            rowIndex,
                            colIndex
                          ),
                        }}
                      >
                        <Select
                          multiple
                          value={userInputs[`${rowIndex}-${colIndex}`] || []}
                          onChange={(e) =>
                            handlePicklistChange(
                              rowIndex,
                              colIndex,
                              e.target.value
                            )
                          }
                          renderValue={(selected) => selected.join(", ")}
                          sx={{ width: "100%" }}
                        >
                          {cellData.picklist.map((option, idx) => (
                            <MenuItem key={idx} value={option.value}>
                              <Checkbox
                                checked={userInputs[
                                  `${rowIndex}-${colIndex}`
                                ]?.includes(option.value)}
                              />
                              <ListItemText primary={option.value} />
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                    );
                  }

                  // Fallback for undefined or unexpected cell types
                  return (
                    <TableCell
                      key={colIndex}
                      align="center"
                      sx={{
                        border: "1px solid grey",
                        fontSize: "1.2rem",
                        backgroundColor: getCellBackground(rowIndex, colIndex),
                      }}
                    >
                      <TextField
                        fullWidth
                        variant="standard"
                        value={
                          userInputs[`${rowIndex}-${colIndex}`] ??
                          (typeof cellData === "object"
                            ? cellData.submittedValue ?? cellData.value
                            : cellData) ??
                          ""
                        }
                        onChange={(e) =>
                          handleTextChange(rowIndex, colIndex, e.target.value)
                        }
                        disabled={isTeacherCommentColumn && !isInstructor}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Assignment;
